import React from 'react';
import { useSelector } from 'react-redux';
import { Trans } from '@wix/yoshi-flow-editor';

import type { IGroupCoverChangedActivity } from 'api/feed/types';
import { selectGroupName, selectGroupSlugById } from 'store/selectors';

import { Link } from '../../Link';

import { IActivityDescriptionProps } from './types';

export function CoverImageChanged(props: IActivityDescriptionProps) {
  const { item, full } = props;

  const data = item?.activity?.data as IGroupCoverChangedActivity;
  const groupId = item.applicationContext?.contextId as string;

  const slug = useSelector(selectGroupSlugById(groupId));
  const groupName = useSelector(selectGroupName(groupId));

  if (full) {
    <Trans
      values={{ groupName }}
      components={[
        <span key={0} />,
        <Link key={1} state="group" params={{ slug }} />,
      ]}
      i18nKey={
        data.hasCoverBefore
          ? 'groups-web.activity-post.cover-image.updated.with-group-name'
          : 'groups-web.activity-post.cover-image.added.with-group-name'
      }
    />;
  }

  return (
    <Trans
      components={[<span key={0} />]}
      i18nKey={
        data.hasCoverBefore
          ? 'groups-web.activity-post.cover-image.updated'
          : 'groups-web.activity-post.cover-image.added'
      }
    />
  );
}

CoverImageChanged.displayName = 'CoverImageChanged';
